import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faEdit, faPlus, faFileAlt, faCommentDots, faLock, faLockOpen, faComments, faSpinner, faCalendar, faCheck, faComment  } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, FormGroup, Input, Label, Alert, Badge, FormText} from 'reactstrap';
import { get, post, patch } from '../../../../helpers/requests';
import { API, BASE_URL, DEFAULT_PAGE_SIZE } from '../../../../CONST';
import BaseModal from '../../../shared/BaseModal';
import { formatDate } from '../prorroga/SolicitudProrroga';
import { fileDownload } from '../../../../helpers/helpers';
import FileTable from '../../../shared/FileTable';
import BaseTable from '../../../shared/BaseTable';
import {
  cellOperation,
  headerOperation,
} from '../../../../helpers/tables';
import { debounce } from 'lodash';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'

const SolicitudesProrroga = ({ client, locationSearch }) => {
  const loginIdToken = useSelector((state) => state.login.id_token);
  const loginState = useSelector((state) => state.login);
  const [prorrogas, setProrrogas] = useState([]);
  const [comentarios, setComentarios] = useState([]);
  const [selectedProrroga, setSelectedProrroga] = useState(null);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [showOpenModal, setShowOpenModal] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [alert, setAlert] = useState({ show: false, message: '', color: 'success' });
  const [documentos, setDocumentos] = useState([]);
  const [downloadingIds, setDownloadingIds] = useState({});
  const [valueFilterNemotecnico, setValueFilterNemotecnico] = useState('');
  const [valueFilterEstado, setValueFilterEstado] = useState('pendientes');
  const [activeFilters, setActiveFilters] = useState({status_filter: 'pendientes'});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    totalItems: 0,
    loading: false
  });
  const [valueFilterAsunto, setValueFilterAsunto] = useState('');

  const [fechaTermino, setFechaTermino] = useState('');
  const [closeComment, setCloseComment] = useState('');

  const debouncedFilterChange = debounce((value) => {
    const newFilters = { ...activeFilters, nemotecnico__icontains: value };
    if (!value) delete newFilters.nemotecnico__icontains;
    setActiveFilters(newFilters);
    setValueFilterNemotecnico(value);
  }, 600);

  const debouncedAsuntoFilterChange = debounce((value) => {
    const newFilters = { ...activeFilters, asunto_correo: value };
    if (!value) delete newFilters.asunto_correo;
    setActiveFilters(newFilters);
    setValueFilterAsunto(value);
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
  }, 600);

  const debouncedStatusFilterChange = debounce((value) => {
    const newFilters = { ...activeFilters };
    if (value) {
      newFilters.status_filter = value;
    } else {
      delete newFilters.status_filter;
    }
    setActiveFilters(newFilters);
    setValueFilterEstado(value);
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
  }, 300);

  const fetchAllProrrogas = async (filters = {}) => {
    try {
      const { pageIndex, pageSize } = pagination;
      let prorrogasUrl = `${BASE_URL}${API.simpleProrroga}/?page=${pageIndex + 1}&page_size=${pageSize}`;

      // Apply filters
      if (filters.nemotecnico__icontains) {
        prorrogasUrl += `&nemotecnico=${encodeURIComponent(filters.nemotecnico__icontains)}`;
      }
      if (filters.status_filter) {
        prorrogasUrl += `&status_filter=${encodeURIComponent(filters.status_filter)}`;
      }
      if (filters.asunto_correo) {
        prorrogasUrl += `&asunto_correo=${encodeURIComponent(filters.asunto_correo)}`;
      }
      const response = await get(prorrogasUrl);
      const { results: prorrogasResponse, count } = response;

      if (!prorrogasResponse || count === 0) {
        setProrrogas([]);
        setComentarios({});
        setPagination(prev => ({ 
          ...prev, 
          totalItems: 0,
          loading: false 
        }));
        return;
      }

      const prorrogaIds = prorrogasResponse.map(p => p.id).join(',');
      const allCommentsResponse = await get(
        `${BASE_URL}${API.simpleProrrogaComentarios}/?prorroga_ids=${prorrogaIds}`
      );

      const commentsByProrroga = allCommentsResponse.reverse().reduce((acc, comment) => {
        const prorrogaId = comment.simple_prorroga_id || comment.prorroga_id || comment.simple_prorroga;
        if (!acc[prorrogaId]) acc[prorrogaId] = [];
        acc[prorrogaId].push(comment);
        return acc;
      }, {});

      const prorrogasWithCounts = prorrogasResponse.map(prorroga => ({
        ...prorroga,
        created_user_name: commentsByProrroga[prorroga.id]?.[0]?.created_user_name || 'Sistema',
        commentCount: commentsByProrroga[prorroga.id]?.length || 0,
      }));

      setProrrogas(prorrogasWithCounts);
      setComentarios(commentsByProrroga);
      setPagination(prev => ({ 
        ...prev, 
        totalItems: count,
        loading: false 
      }));
    } catch (error) {
      showAlert('Error al cargar los datos', 'danger');
      console.error('Error in fetchAllProrrogas:', error);
      setPagination(prev => ({ ...prev, loading: false }));
    }
  };

  const NemotecnicoFilter = ({ filter, onChange, loading, value }) => {
    const [inputValue, setInputValue] = useState(value || '');

    useEffect(() => {
      setInputValue(value || '');
    }, [value]);

    const handleChange = (e) => {
      const newValue = e.target.value;
      setInputValue(newValue);
      onChange(newValue);
    };

    return (
      <div style={{ position: 'relative' }}>
        <input
          type="text"
          value={inputValue}
          onChange={handleChange}
          className="form-control"
        />
        {loading && (
          <div style={{
            position: 'absolute',
            right: '10px',
            top: '10px',
            pointerEvents: 'none'
          }}>
            <FontAwesomeIcon icon={faSpinner} spin />
          </div>
        )}
      </div>
    );
  };

  const StatusFilter = ({ filter, onChange, loading, value }) => {
    const [selectValue, setSelectValue] = useState(value || '');

    useEffect(() => {
      setSelectValue(value || '');
    }, [value]);

    const handleChange = (e) => {
      const newValue = e.target.value;
      setSelectValue(newValue);
      onChange(newValue);
    };

    return (
      <div style={{ position: 'relative' }}>
        <select
          value={selectValue}
          onChange={handleChange}
          className="form-control"
          style={{ fontSize: '0.875rem' }}
        >
          <option value="">Todos</option>
          <option value="pendientes">Pendientes</option>
          <option value="cerradas">Resueltas</option>
        </select>
        {loading && (
          <div style={{
            position: 'absolute',
            right: '10px',
            top: '10px',
            pointerEvents: 'none'
          }}>
            <FontAwesomeIcon icon={faSpinner} spin />
          </div>
        )}
      </div>
    );
  };

  const handleFilterChange = (filters) => {
    setPagination(prev => ({ ...prev, pageIndex: 0 }));
    fetchAllProrrogas(filters);
  };

  const fetchProrrogaComentarios = async (prorrogaId, force = false) => {
    if (!force && comentarios[prorrogaId]) return;

    try {
      const comentariosResponse = await get(
        `${BASE_URL}${API.simpleProrrogaComentarios}/?prorroga_id=${prorrogaId}`
      );

      const orderedComments = [...comentariosResponse].reverse();

      setComentarios(prev => ({
        ...prev,
        [prorrogaId]: orderedComments
      }));
    } catch (error) {
      console.error('Error loading comments:', error);
    }
  };

  useEffect(() => {
    if (!showCommentModal || !selectedProrroga?.id) return;

    fetchProrrogaComentarios(selectedProrroga.id, true);

    const intervalId = setInterval(() => {
      fetchProrrogaComentarios(selectedProrroga.id, true);
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [showCommentModal, selectedProrroga?.id]);
  

  useEffect(() => {
    const fetchData = async () => {
      setPagination(prev => ({ ...prev, loading: true }));
      await fetchAllProrrogas(activeFilters);
    };

    let isMounted = true;
    fetchData();
    return () => { isMounted = false };
  }, [pagination.pageIndex, activeFilters]);

  const handlePageChange = (pageIndex) => {
    setPagination(prev => ({ ...prev, pageIndex }));
  };

  const handleCloseProrroga = async () => {
    if (!fechaTermino) {
      showAlert('Debe especificar la fecha de término de la prórroga', 'warning');
      return;
    }

    try {
      let comentarioId = null;
      if (closeComment.trim()) {
        const commentResponse = await post(`${BASE_URL}${API.simpleProrrogaComentarios}/`, {
          simple_prorroga: selectedProrroga.id,
          comentario: `PRÓRROGA RESUELTA - Fecha término: ${fechaTermino}\n\n${closeComment}`,
          documentos: [],
          created_by: parseInt(loginState.user.sub, 10),
        });
        comentarioId = commentResponse.id;
      }

      await patch(`${BASE_URL}${API.simpleProrroga}/${selectedProrroga.id}/`, {
        is_open: false,
        who: loginState.user.full_name,
        fecha_termino: fechaTermino,
        comentario_id: comentarioId,
      });

      showAlert('Prórroga cerrada correctamente', 'success');
      setFechaTermino('');
      setCloseComment('');
      fetchAllProrrogas(activeFilters);
      setShowCloseModal(false);
    } catch (error) {
      showAlert('Error al cerrar la prórroga', 'danger');
      console.error('Error closing prorroga:', error);
    }
  };

  const handleOpenProrroga = async () => {
    try {
      await patch(`${BASE_URL}${API.simpleProrroga}/${selectedProrroga.id}/`, {
        is_open: true
      });
      showAlert('Prórroga abierta correctamente', 'success');
      fetchAllProrrogas(activeFilters);
      setShowOpenModal(false);
    } catch (error) {
      showAlert('Error al cerrar la prórroga', 'danger');
    }
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) return;
    const commentText = newComment;
    const filesToUpload = [...documentos];

    try {
      setNewComment('');
      setDocumentos([]);

      const response = await post(`${BASE_URL}${API.simpleProrrogaComentarios}/`, {
        simple_prorroga: selectedProrroga.id,
        comentario: commentText,
        documentos: documentos.map(file => ({ uuid: file.uuid })),
        created_by: parseInt(loginState.user.sub, 10),
      });

      setComentarios(prev => ({
        ...prev,
        [selectedProrroga.id]: [
          ...(prev[selectedProrroga.id] || []),
          response
        ]
      }));

      showAlert('Comentario agregado correctamente', 'success');
    } catch (error) {
      setNewComment(commentText);
      setDocumentos(filesToUpload);

      showAlert('Error al agregar comentario', 'danger');
      console.error('Error adding comment:', error);
    }
  };

  const showAlert = (message, color) => {
    setAlert({ show: true, message, color });
    setTimeout(() => setAlert({ show: false, message: '', color: 'success' }), 5000);
  };

  const hasDocuments = (prorrogaId) => {
    return comentarios[prorrogaId]?.some(c => c.documentos_ids?.length > 0);
  };

  useEffect(() => {
    if (showCommentModal && selectedProrroga?.id && !comentarios[selectedProrroga.id]) {
      fetchProrrogaComentarios(selectedProrroga.id);
    }
  }, [showCommentModal, selectedProrroga])

  useEffect(() => {
    const timer = setTimeout(() => {
      const container = document.querySelector('.prorroga-chat-container');
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [comentarios, selectedProrroga?.id, showCommentModal]);

  const formatDateOnly = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  const prorrogasColumns = [
    {
      Header: headerOperation('ID'),
      id: 'id',
      accessor: 'id',
      Cell: (row) => cellOperation(row.value),
      filterable: false,
      sortable: false,
      width: 60,
    },
    {
      Header: headerOperation('Póliza'),
      id: 'nemotecnico__icontains',
      accessor: 'nemotecnico',
      Cell: (row) => cellOperation(row.value),
      Filter: ({ filter }) => (
        <NemotecnicoFilter 
          filter={filter} 
          onChange={debouncedFilterChange}
          loading={pagination.loading}
          value={valueFilterNemotecnico}
        />
      ),
      sortable: false,
    },
    {
      Header: headerOperation('Asegurado'),
      id: 'asegurado',
      accessor: 'asegurado',
      Cell: (row) => cellOperation(row.value),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Usuario'),
      id: 'created_user_name',
      accessor: 'created_user_name',
      Cell: (row) => cellOperation(row.value || 'N/A'),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Fecha Solicitud'),
      id: 'created_ts',
      accessor: 'created_ts',
      Cell: (row) => cellOperation(formatDate(row.value)),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Fecha Término'),
      id: 'fecha_termino',
      accessor: 'fecha_termino_actual',
      Cell: (row) => cellOperation(
        row.value ? formatDateOnly(row.value) : 
        <span className="text-muted">Pendiente</span>
      ),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Asunto'),
      id: 'asunto_correo',
      accessor: 'asunto_correo',
      Cell: (row) => cellOperation(row.value),
      Filter: ({ filter }) => (
        <NemotecnicoFilter 
          filter={filter} 
          onChange={debouncedAsuntoFilterChange}
          loading={pagination.loading}
          value={valueFilterAsunto}
        />
      ),
      sortable: false,
    },
    {
      Header: headerOperation('Estado'),
      id: 'status_filter',
      accessor: 'is_open',
      Cell: (row) => cellOperation(
        <Badge color={row.value ? 'success' : 'danger'}>
          {row.value ? 'Pendiente' : 'Resuelto'}
        </Badge>,
        'center'
      ),
      Filter: ({ filter }) => (
        <StatusFilter 
          filter={filter} 
          onChange={debouncedStatusFilterChange}
          loading={pagination.loading}
          value={valueFilterEstado}
        />
      ),
      sortable: false,
    },
    {
      Header: headerOperation('Comentarios'),
      id: 'commentCount',
      accessor: 'commentCount',
      Cell: (row) => cellOperation(
        <Button 
          color="link" 
          onClick={() => {
            setSelectedProrroga(row.original);
            setShowCommentModal(true);
          }}
          style={{ padding: 0 }}
        >
          <FontAwesomeIcon icon={faEdit} /> ({row.value})
        </Button>, 'center'
      ),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Documentos'),
      id: 'documentos',
      accessor: 'id',
      Cell: (row) => cellOperation(
        hasDocuments(row.value) ? (
          <button
            type="button"
            className="table-link"
            onClick={() => {
              if (downloadingIds[row.value]) return;
              setDownloadingIds(prev => ({ ...prev, [row.value]: true }));
              fileDownload(
                `${BASE_URL}${API.simpleProrrogaComentarios}/${row.value}/download_all`,
                loginIdToken,
                () => setDownloadingIds(prev => ({ ...prev, [row.value]: false }))
              );
            }}
            disabled={downloadingIds[row.value]}
            title={downloadingIds[row.value] ? "Descargando..." : "Descargar documentos"}
          >
            <FontAwesomeIcon 
              icon={downloadingIds[row.value] ? faSpinner : faDownload} 
              spin={downloadingIds[row.value]}
            />
          </button>
        ) : null, 'center'
      ),
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Acciones'),
      id: 'acciones',
      accessor: 'is_open',
      Cell: (row) => (
        <div className="table-cell" style={{ textAlign: 'center' }}>
          {row.value ? (
            <Button 
              color="danger"
              size="sm"
              onClick={() => {
                setSelectedProrroga(row.original);
                setShowCloseModal(true);
              }}
              style={{ padding: '0.25rem 0.5rem' }}
            >
              <FontAwesomeIcon icon={faLock} /> Cerrar
            </Button>
          ) : (
            <Button 
              color="success"
              size="sm"
              onClick={() => {
                setSelectedProrroga(row.original);
                setShowOpenModal(true);
              }}
              style={{ padding: '0.25rem 0.5rem' }}
            >
              <FontAwesomeIcon icon={faLockOpen} /> Abrir
            </Button>
          )}
        </div>
      ),
      filterable: false,
      sortable: false,
      width: 120,
    }
  ];

  return (
    <Col md={{ size: 12 }}>
      {alert.show && <Alert color={alert.color}>{alert.message}</Alert>}

      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Solicitudes de Prórroga</h4>
      </div>

      <BaseTable
        columns={prorrogasColumns}
        data={prorrogas}
        resultCount={pagination.totalItems}
        pageSize={pagination.pageSize}
        pages={Math.ceil(pagination.totalItems / pagination.pageSize)}
        loading={pagination.loading}
        onPageChange={handlePageChange}
        showBorders={false}
        onFilteredChange={handleFilterChange}
        filterable
        manual
      />

      <BaseModal
        modalOpen={showCommentModal}
        handleModal={() => setShowCommentModal(false)}
        title={`Comentarios para Prórroga - ${selectedProrroga?.asunto_correo || ''}`}
        type="prorroga-comments-modal"
        backdrop="static"
        size="xl"
      >
        {selectedProrroga && (
          <div className="prorroga-modal-content">
            {/* Left Column - Chat */}
            <div className="prorroga-chat-column">
              <div className="prorroga-chat-container">
                <div className="prorroga-chat-inner">
                  {comentarios[selectedProrroga.id]?.length === 0 ? (
                    <div className="prorroga-chat-empty-state">
                      <div className="prorroga-chat-empty-icon">
                        <FontAwesomeIcon icon={faComments} />
                      </div>
                      <p>No hay comentarios para esta prórroga</p>
                    </div>
                  ) : (
                    comentarios[selectedProrroga.id]?.map((comentario) => {
                      const isOrsan = comentario.is_orsan;
                      const messageType = isOrsan ? 'orsan' : 'external';

                      return (
                        <div 
                          key={comentario.id} 
                          className={`prorroga-chat-message-wrapper ${messageType}`}
                        >
                          <div className={`prorroga-chat-message ${messageType}`}>
                            {/* User info header */}
                            <div className="prorroga-chat-user-header">
                              <div>
                                <strong className={`prorroga-chat-user-name ${messageType}`}>
                                  {comentario.created_user_name || 'Usuario'}
                                  {isOrsan && (
                                    <span className="prorroga-chat-orsan-badge">
                                      ORSAN
                                    </span>
                                  )}
                                </strong>
                              </div>
                              <small className={`prorroga-chat-timestamp ${messageType}`}>
                                {formatDate(comentario.created_ts)}
                              </small>
                            </div>
                                
                            {/* Message content */}
                            <div className="prorroga-chat-content">
                              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                {comentario.comentario}
                              </ReactMarkdown>
                            </div>
                                
                            {/* Attachments */}
                            {comentario.documentos_ids?.length > 0 && (
                              <div className={`prorroga-chat-attachments ${messageType}`}>
                                <button
                                  type="button"
                                  className={`prorroga-chat-attachment-btn ${messageType}`}
                                  onClick={() =>
                                    fileDownload(
                                      `${BASE_URL}${API.simpleProrrogaComentarios}/${comentario.id}/download`,
                                      loginIdToken,
                                    )
                                  }
                                  title="Descargar archivos adjuntos"
                                >
                                  <FontAwesomeIcon icon={faDownload} className="mr-1" />
                                  Archivos ({comentario.documentos_ids.length})
                                </button>
                              </div>
                            )}

                            {/* Chat bubble tail */}
                            <div className={`prorroga-chat-tail ${messageType}`}></div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
            
            {/* Right Column - New Comment Section */}
            <div className="prorroga-form-column">
              <div className="prorroga-new-comment-section">
                <FormGroup>
                  <Label className="prorroga-comment-label">
                    <FontAwesomeIcon icon={faCommentDots} className="mr-1" />
                    Nuevo Comentario
                  </Label>
                  <Input
                    type="textarea"
                    rows={8}
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    placeholder="Escribe tu comentario aquí..."
                    className="prorroga-comment-textarea"
                  />
                  <FormText className="font-italic">Formato Markdown soportado</FormText>
                </FormGroup>

                <FormGroup>
                  <Label for="documentos" className="prorroga-comment-label mb-2">
                    <FontAwesomeIcon icon={faFileAlt} className="mr-1" />
                    Documentos
                  </Label>
                  <div className="prorroga-file-upload-container">
                    <FileTable
                      newFiles={documentos}
                      handleAdd={(file) => setDocumentos((prev) => [...prev, file])}
                      handleDeleteNew={(file) => setDocumentos((prev) => prev.filter((doc) => doc.uuid !== file.uuid))}
                      loginIdToken={loginIdToken}
                      uploadUrl={`${BASE_URL}${API.uploadDocumento}/`}
                      previewFileUrl={`${BASE_URL}${API.tempFileDownload}/`}
                      previewFile
                      individualMaxFileSize={13}
                      globalMaxFileSize={20}
                      disabled={!selectedProrroga.is_open}
                    />
                  </div>
                </FormGroup>

                <div className="prorroga-submit-container">
                  <Button 
                    color="primary"
                    className="prorroga-add-comment-btn"
                    onClick={handleAddComment}
                    disabled={!newComment.trim()}
                    block
                  >
                    <FontAwesomeIcon icon={faPlus} className="mr-1" />
                    Agregar Comentario
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </BaseModal>

      {/* Close Prorroga Modal */}
      <BaseModal
        modalOpen={showCloseModal}
        handleModal={() => {
          setShowCloseModal(false);
          setFechaTermino('');
          setCloseComment('');
        }}
        title={`Resolver Prórroga #${selectedProrroga?.id || ''}`}
        size="lg"
      >
        {selectedProrroga && (
          <>
            <p className="mb-4">Complete la información para resolver esta prórroga:</p>

            <FormGroup>
              <Label for="fecha-termino">
                <FontAwesomeIcon icon={faCalendar} className="mr-1" />
                Fecha de Término de la Prórroga *
              </Label>
              <Input
                id="fecha-termino"
                type="date"
                value={fechaTermino}
                onChange={(e) => setFechaTermino(e.target.value)}
                min={new Date().toISOString().split('T')[0]}
                className="mb-2"
              />
              <FormText color="muted">
                Fecha hasta la cual se extiende el plazo
              </FormText>
            </FormGroup>
        
            <FormGroup>
              <Label for="close-comment">
                <FontAwesomeIcon icon={faComment} className="mr-1" />
                Comentario de Resolución (opcional)
              </Label>
              <Input
                id="close-comment"
                type="textarea"
                rows={3}
                value={closeComment}
                onChange={(e) => setCloseComment(e.target.value)}
                placeholder="Agregar comentarios sobre la resolución..."
              />
            </FormGroup>
        
            <div className="d-flex justify-content-end mt-4">
              <Button 
                color="secondary" 
                onClick={() => {
                  setShowCloseModal(false);
                  setFechaTermino('');
                  setCloseComment('');
                }}
                className="mr-1"
              >
                Cancelar
              </Button>
              <Button 
                color="danger" 
                onClick={handleCloseProrroga}
                disabled={!fechaTermino}
              >
                <FontAwesomeIcon icon={faCheck} className="mr-1" />
                Confirmar Resolución
              </Button>
            </div>
          </>
        )}
      </BaseModal>

      {/* Open Prorroga Modal */}
      <BaseModal
        modalOpen={showOpenModal}
        handleModal={() => setShowOpenModal(false)}
        title={`Abrir Prórroga #${selectedProrroga?.id || ''}`}
      >
        {selectedProrroga && (
          <>
            <p>¿Estás seguro que deseas abrir esta prórroga?</p>
            <div className="d-flex justify-content-end">
              <Button 
                color="secondary" 
                onClick={() => setShowOpenModal(false)}
                className="mr-1"
              >
                Cancelar
              </Button>
              <Button 
                color="success" 
                onClick={handleOpenProrroga}
              >
                Confirmar Apertura
              </Button>
            </div>
          </>
        )}
      </BaseModal>
    </Col>
  );
};

export default SolicitudesProrroga;